<template>
  <div id="app">
    <router-view />

    <layout-notification />

    <confirm
      v-if="showConfirm"
      v-model="showConfirm"
      :show-close-button="confirm.showCloseButton"
      :close-button="confirm.closeButton"
      :submit-button="confirm.submitButton"
      :title="confirm.title"
      :description="confirm.description"
      @submit="onConfirmSubmit"
      @cancel="onConfirmCancel"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import LayoutNotification from '@/components/appLayout/Notification.vue';
import Confirm from '@/components/dialogs/Confirm.vue';

export default {
  components: { LayoutNotification, Confirm },
  data() {
    return {
      showConfirm: false
    };
  },
  computed: mapState({
    confirm: state => state.confirm.confirm,
    appTitle: state => state.system.appTitle
  }),
  watch: {
    confirm(to, from) {
      if (to) {
        this.showConfirm = true;
      }
    }
  },
  created() {
    document.title = this.appTitle;
  },
  methods: {
    onConfirmSubmit() {
      if (this.confirm.onSuccess) {
        this.confirm.onSuccess();
      }
      this.$nextTick(() => (this.showConfirm = false));
    },
    onConfirmCancel() {
      if (this.confirm.onCancel) {
        this.confirm.onCancel();
      }
      this.$nextTick(() => (this.showConfirm = false));
    }
  }
};
</script>
